import React, { useEffect, useRef, useState } from 'react';
import { EMPTY_FUNCTION } from 'Utils/constants';

const Dropdown = props => {
  const {
    toggleElement,
    children,
    align = 'start',
    className = '',
    wrapperClassName = '',
    showOnHover = false,
    dropdownHeight = null,
    onCloseDropdown = EMPTY_FUNCTION,
    onOpenDropdown = EMPTY_FUNCTION,
    offsetValues = { top: 0, bottom: 0 },
  } = props;

  const [dropdownValues, setDropdownValues] = useState({
    show: false,
    style: {},
  });
  const toggleRef = useRef(null);
  const dropdownRef = useRef(null);
  const getStyle = (visibility = 'visible') => {
    const style = {};
    const toggleEle = toggleRef.current;
    if (toggleEle) {
      const toggleCoordinates = toggleEle.getBoundingClientRect();
      style.visibility = visibility;
      style.position = showOnHover ? 'fixed' : 'absolute';
      const { top, height, left, right, bottom } = toggleCoordinates;
      if (align === 'start') style.left = left;
      else style.right = window.innerWidth - right;

      const dropdownElement = dropdownRef.current;
      const topSpace = top - (offsetValues.top || 0);
      const bottomSpace =
        window.innerHeight - bottom - (offsetValues.bottom || 0);

      if (dropdownHeight !== null) {
        if (dropdownHeight > bottomSpace) style.bottom = bottomSpace + height;
        else style.top = top + height;
      } else if (dropdownElement) {
        if (dropdownElement.scrollWidth > window.innerWidth - right) {
          style.right = window.innerWidth - right;
          style.left = 'auto';
        } else if (dropdownElement.scrollWidth > left) {
          style.left = left;
          style.right = 'auto';
        }
        if (
          dropdownElement &&
          dropdownElement.scrollHeight > bottomSpace &&
          topSpace > bottomSpace
        ) {
          style.bottom = bottomSpace + height;
          style.maxHeight = topSpace;
        } else {
          style.top = top + height;
          style.maxHeight = window.innerHeight - (top + height);
        }
      } else {
        style.top = top + height;
        style.maxHeight = window.innerHeight - (top + height);
      }
    }
    return style;
  };

  const toggleDropdown = show => {
    let style = {};
    if (show) style = getStyle();
    setDropdownValues({ show, style });
  };

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (dropdownValues.show) {
      setDropdownValues({
        show: true,
        style: getStyle(),
      });
      onOpenDropdown();
    }
    onCloseDropdown();
  }, [dropdownValues.show]);

  useEffect(() => {
    if (dropdownValues.style.visibility === 'hidden')
      setDropdownValues({ ...dropdownValues, style: getStyle('visible') });
  }, [dropdownValues.style]);
  return (
    <div
      className={`dropdown ${wrapperClassName}`.trim()}
      onClick={() => {
        if (!showOnHover) toggleDropdown(!dropdownValues.show);
      }}
    >
      {showOnHover ? (
        <div
          className="toggle-wrap hover-toggle"
          ref={toggleRef}
          onMouseEnter={() => {
            setDropdownValues({ ...dropdownValues, style: getStyle('hidden') });
          }}
        >
          {toggleElement}
          <div
            className={`dropdown-wrapper animatedDropDown animatedFast${
              dropdownValues.style.bottom ? ' drop-up' : ''
            } ${className}`}
            ref={dropdownRef}
            style={dropdownValues.style}
          >
            {children}
          </div>
        </div>
      ) : (
        <>
          <div className="toggle-wrap" ref={toggleRef}>
            {toggleElement}
          </div>
          {dropdownValues.show && (
            <div className="layout-wrap">
              <div
                className={`dropdown-wrapper animatedDropDown animatedFast${
                  dropdownValues.style.bottom ? ' drop-up' : ''
                } ${className}`}
                ref={dropdownRef}
                style={dropdownValues.style}
              >
                {children}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Dropdown;
